module.exports = __webpack_public_path__ + "static/img/lesson-poster.398c5bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/old_age_education/lesson-poster.png
// module id = 76KT
// module chunks = 1